<template>
  <section class="content">
    <admin-header
      :title="'Point To Port'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminPointToPort',
    data () {
      return {
        newEntityScreen: 'Admin - Point To Ports',
        searchEntityScreen: 'Admin - Point To Port search',
        filterEventName: 'admin-point-to-port-filter',
        filterName: 'PointToPortFilter',
        entityName: 'point-to-port',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/PointToPort/AdminPointToPort.vue